export default __webpack_public_path__ + "static/media/Head_6_Ear_1_C3.eb4a82da.svg";